
    import Vue from 'vue';
    import {mapState} from 'vuex';
    // Components
    import RomaOrganizer from '@/components/units/RomaOrganizer.vue';
    import RomaUnitList from '@/components/units/RomaUnitList.vue';
    // Store
    import School from '@/store/commons/School';
    // Interfaces
    import {ISchool} from "@/interfaces/commons/ISchool";
    import {Item} from '@vuex-orm/core';

    export default Vue.extend({
        name: 'OrganizerPage',
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if (vm.school) {
                    return true;
                } else {
                    return {name: 'home'};
                }

            });
        },
        data() {
            return {
                firstSearch: false,
            };
        },
        computed: {
            ...mapState(['user']),
            school(): Item<ISchool> {
                const index = this.$store.state.organizer.selectedSchool.id;
                return School.query()
                    .whereId(index)
                    .first();
            },
        },
        methods: {
            searchAnualPlans(){
                this.firstSearch = true;
                this.$refs.romaUnitListRef.getAnualPlansByPage(1);
            },
        },
        components: {
            RomaOrganizer,
            RomaUnitList,
        },
    });
